import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useIsAdmin } from 'hooks/useRoleCheck';
import { withGreyBackground } from 'pages/v2/WithGreyBackground';
import { CommentLogView } from 'pages/v2/comment-log/EpdCommentLogPage';
import EpdRoutes from 'routes/EpdRoutes';
import { useDocumentCommentLog } from './useDocumentCommentLog';

export const DynamicFormCommentLogPage: React.FC = () => {
  const { docId } = useParams<{ docId: string }>();
  const isAdmin = useIsAdmin();
  const { data, isLoading } = useDocumentCommentLog(docId, isAdmin);

  if (!isAdmin) {
    return <Redirect to={EpdRoutes.forbidden} />;
  }

  return <CommentLogView data={data} isLoading={isLoading} />;
};

export default withGreyBackground(DynamicFormCommentLogPage);
